const LoginButton = ({ onLogin = () => null, ...otherProps }) => {
  return (
    <button
      {...otherProps}
      onClick={onLogin}
      className="shadow active:skew-y-0 hover:skew-y-3 shadow-secondary font-ubuntuBold rounded px-4 py-2 bg-primary text-white hover:bg-secondary"
    >
      Login
    </button>
  );
};

export default LoginButton;
